
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","aria-label":"Records with Locations","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 22a9 9 0 119-9 9 9 0 01-9 9zm0-16a7 7 0 107 7 7 7 0 00-7-7z"}}),_c('path',{attrs:{"d":"M26 12H14V0h-2v12H0v2h12v12h2V14h12v-2z"}})])
          )
        }
      }
    